import React from 'react';
export function FooterCTA() {
  return <footer className="py-16 md:py-20 bg-black border-t border-white/10 text-center" data-id="element-60">
      <div className="container mx-auto px-4" data-id="element-61">
        <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6 max-w-3xl mx-auto" data-id="element-62">
          Dejá de perder plata en creativos que no venden
        </h2>
        <p className="text-gray-400 mb-8 text-base md:text-lg max-w-2xl mx-auto" data-id="element-63">
          +100 creativos que convierten en menos de 10 minutos
        </p>

        <a href="#pricing" className="inline-block bg-white text-black hover:bg-gray-200 font-bold text-lg md:text-xl py-4 px-8 md:px-12 rounded-full shadow-lg transform hover:-translate-y-1 transition-all duration-300 mb-6" data-id="element-64">
          ACCEDER A LA APP →
        </a>

        <p className="text-sm text-gray-500 mb-12" data-id="element-65">
          $77.700 ARS - Pago Único - Garantía 72hs
        </p>

        <div className="text-xs text-gray-700" data-id="element-66">
          &copy; {new Date().getFullYear()} Techain AdAngle. Todos los derechos
          reservados.
        </div>
      </div>
    </footer>;
}